import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getHRSolutions(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Personalistické a náborové firmy",
		},
		{
			desc: "Startupy, malé i středně velké podniky",
		},
		{
			desc: "Veřejné instituce (úřady, školy apod.)",
		},
	];
}
